<ng-container *ngIf="component.data$ | async as data">
  <py-media-icon
    [type]="data?.mediaLoc?.mime === 'application/pdf' ? 'file-pdf' : 'file'"
    [url]="data?.mediaLoc?.url"
    [label]="data?.linkName || data?.mediaLoc?.code"
    [target]="'_blank'"
  ></py-media-icon>
</ng-container>
